import React from 'react';
import { Box, Typography, Paper, Container, Link } from '@mui/material';

const CommunityRulesPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          📜 Правила сообщества
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          Сервис https://nashrelax.ru
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Дата вступления в силу: 05.04.2026 года
        </Typography>

        <Paper sx={{ p: 4, mt: 3 }}>
          {/* Вводная часть */}
          <Typography paragraph>
            Сервис <strong>https://nashrelax.ru</strong> — это место, где можно найти друзей,
            компанию для спорта и отдыха, основываясь на общих интересах.
          </Typography>
          <Typography paragraph>
            <strong>Будьте активнее:</strong>
          </Typography>
          <ul>
            <li>Создавайте свои мероприятия</li>
            <li>Подключайтесь на интересные вам мероприятия</li>
            <li>Соблюдайте договорённости и будьте пунктуальны</li>
          </ul>
          <Typography paragraph>
            Помните, что успех любого мероприятия и развитие этого Сервиса зависят от активности
            и уровня культуры каждого из участников.
          </Typography>
          <Typography paragraph>
            Мы хотим, чтобы каждому пользователю Сервиса https://nashrelax.ru было комфортно и
            безопасно, поэтому тщательно следим за соблюдением Правил сообщества, которые описаны
            ниже. Несоблюдение этих рекомендаций может иметь реальные последствия — от предупреждения
            до блокировки аккаунта или обращения в правоохранительные органы.
          </Typography>

          {/* 1. Уважай личные границы */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            1. Уважай личные границы
          </Typography>
          <Typography paragraph>
            Каждый участник имеет право выбрать только те мероприятия и тех организаторов, которых
            считает интересными и безопасными. Каждый организатор имеет право устанавливать разумные
            границы для сбора участников (количество участников, уровень культуры, физической
            подготовки, возраст и т.д.).
          </Typography>

          {/* 2. Делись информацией обдуманно */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            2. Делись информацией обдуманно
          </Typography>
          <Typography paragraph>
            Не публикуй в анкете и открытых мероприятиях личную информацию или способы для связи:
            адрес почты, номер телефона, аккаунты в соцсетях, никнеймы в мессенджерах. Не переходи
            в другие мессенджеры, пока не убедишься в безопасности. Если в первом сообщении тебе
            предлагают перейти в мессенджер, лучше воздержаться, потому что так часто поступают
            мошенники.
          </Typography>

          {/* 3. Будь собой */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            3. Будь собой
          </Typography>
          <Typography paragraph>
            Не создавай фейковые аккаунты, не размещай чужие фотографии. Пользователи любят честность
            и хотят получать достоверную информацию. Публикуй достаточно подробную и значимую
            информацию. Избегай избыточной информации.
          </Typography>

          {/* 4. Недопустима организация мероприятий, отличающихся по тематике */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            4. Недопустима организация мероприятий, отличающихся по тематике от категорий, указанных в приложении
          </Typography>
          <Typography paragraph>
            Если тебе не хватает имеющихся в приложении категорий, напиши нам:{' '}
            <strong>asc.asp@yandex.ru</strong>. Мы обязательно рассмотрим вашу просьбу о расширении
            каталога.
          </Typography>

          {/* 5. Не рекламируй себя и свои товары */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            5. Не рекламируй себя и свои товары
          </Typography>
          <Typography paragraph>
            Сервис https://nashrelax.ru — это место, где организуют активный отдых, спортивные
            мероприятия и тренировки. Не рекламируй, не продвигай, не продавай пользователям товары
            (в том числе — и особенно — спортивное питание), услуги, информацию, даже если она
            косвенно связана с организованным мероприятием. Не размещай ссылки на свои аккаунты,
            чтобы привлечь подписчиков. Если вы являетесь тренером, если вы тренируете за
            вознаграждение, укажите эту информацию явно в карточке мероприятия.
          </Typography>

          {/* 6. Мы против насилия */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            6. Мы против насилия
          </Typography>
          <Typography paragraph>
            Не размещай в анкете фотографии и изображения, содержащие насильственные действия,
            кровь, оружие, военные действия. Мы за мир и спокойствие. Все мероприятия должны быть
            безопасными для организаторов и участников.
          </Typography>

          {/* 7. Общайся уважительно */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            7. Общайся уважительно
          </Typography>
          <Typography paragraph>
            Мы против ненависти. Мы никогда не будем поддерживать расизм, фанатизм, ненависть или
            насилие из-за личности и внешности.
          </Typography>

          {/* 8. Не навязывай */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            8. Не навязывай
          </Typography>
          <Typography paragraph>
            Избегай проявления и навязывания субкультурных ценностей, в том числе, но не только:
            правил поведения, идеологии, тематики, формы общения. Помни, что данное приложение
            создано и работает для организации активного досуга и спортивных мероприятий.
          </Typography>

          {/* 9. Соблюдай закон */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            9. Соблюдай закон
          </Typography>
          <Typography paragraph>
            У нас запрещены любые действия, нарушающие закон. Соблюдай положения действующего
            законодательства Российской Федерации.
          </Typography>

          {/* 10. Как сообщить о проблеме или нарушении */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            10. Как сообщить о проблеме или нарушении правил
          </Typography>
          <Typography paragraph>
            Высказывайся и говори открыто. Если кто-то причиняет тебе вред, заставляет чувствовать
            себя некомфортно или нарушает наши Правила, сообщи об этом. Жалобы полностью
            конфиденциальны. Сообщая о нарушениях, ты помогаешь нам пресечь вредоносное поведение
            и защитить других.
          </Typography>
          <Typography paragraph>
            Мы серьёзно относимся к нашим Правилам сообщества и к их влиянию на наше сообщество.
            Мы сделаем всё возможное, чтобы люди им следовали. Мы можем предупредить о нарушении,
            но можем заблокировать аккаунт и без предупреждения, если считаем, что нарушение
            серьёзное.
          </Typography>
          <Typography paragraph>
            Мы оставляем за собой право проводить расследования и/или прекращать действия аккаунтов
            без возмещения каких-либо покупок в случае злоупотребления Сервисом или поведения,
            которое, по нашему мнению, является неуместным, незаконным или нарушающим наши Правила
            сообщества, включая действия или общение, которые происходят за пределами Приложения,
            но связаны с людьми, которые встретились в Приложении.
          </Typography>

          <Box sx={{ mt: 4, p: 3, bgcolor: 'warning.light', borderRadius: 2 }}>
            <Typography variant="body2">
              <strong>Важно:</strong> Используя Сервис, вы подтверждаете, что ознакомились
              с Правилами сообщества и обязуетесь их соблюдать.
            </Typography>
          </Box>
        </Paper>

        <Box sx={{ mt: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Link href="/events" underline="hover">
            ← Вернуться к мероприятиям
          </Link>
          <Link href="/privacy-policy" underline="hover" target="_blank" rel="noopener noreferrer">
            Политика конфиденциальности →
          </Link>
          <Link href="/terms-of-service" underline="hover" target="_blank" rel="noopener noreferrer">
            Пользовательское соглашение →
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default CommunityRulesPage;
